import {useEffect, useState} from 'react';
import AssessmentFolder from './components/assessmentFolder';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {agyleAssessmentList} from '../../../../store/reducers/dicts';
import _ from 'lodash';
import makeStyles from '@mui/styles/makeStyles';
import {isPatientED, PATIENT_CONTEXT_TYPE} from '../../../../util/patientContextUtil';
import {assessmentsConfig} from '../../../../store/reducers/externalConfig';
import AssessmentButton from './components/assessmentButton';
import {favouritesAssessments} from '../../../../store/reducers/preferences';
import {selectedMap} from '../../../../store/reducers/reviews';
import {ctxAssessmentFilters, ctxPatientType, filterAssessmentList} from '../../../../store/reducers/patientContext';

const useStyles = makeStyles((theme) => ({
    assessments: {
        display: 'flex',
        gap: 10,
        alignItems: 'center',
    },
    title: {
        fontWeight: 'bold',
        fontSize: 'large',
    },
    counter: {
        backgroundColor: theme.palette.inPatient.accordionBackground,
        borderRadius: 6,
        padding: 5,
        width: 30,
        height: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        gap: 15,
        paddingTop: 5,
        paddingLeft: 20,
    },
}));

const AssessmentsFolders = ({disableSave, patient}) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch();

    // Selectors
    const assessmentList = useSelector(agyleAssessmentList);
    const assessmentsCfg = useSelector(assessmentsConfig);
    const favAssessments = useSelector(favouritesAssessments);
    const filter = useSelector(ctxAssessmentFilters);
    const wardMap = useSelector(selectedMap);
    const patientType = useSelector(ctxPatientType);

    const [assessmentsActive, setAssessmentsActive] = useState([]);
    const [specialtyFolder, setSpecialtyFolder] = useState([]);
    const [suggestedFolder, setSuggestedFolder] = useState([]);
    const [favouritesFolder, setFavouritesFolder] = useState([]);
    const [mandatoryFolder, setMandatoryFolder] = useState([]);

    const isED = isPatientED(patientType);

    useEffect(() => {
        const onlyActive = _.filter(assessmentList, {active: true});
        setAssessmentsActive(dispatch(filterAssessmentList(onlyActive)));
    }, [assessmentList, filter]);

    useEffect(() => {
        if (assessmentList?.length > 0) {
            setMandatoryFolder(getAssessment('mandatory'));
            setSuggestedFolder(getAssessment('suggested'));
            setFavouritesFolder(prepareAssessmentList(favAssessments || []));
            // TODO HERE
            if (!_.isNil(wardMap)) {
                const flatWardSpec = _.flatMap(wardMap.specialtyRestriction).map(spec => spec.__id);
                const filteredObjects = _.filter(assessmentList, (assessment) =>
                    _.some(assessment.specialties, (specItem) => _.includes(flatWardSpec, specItem)),
                );
                const assessmentIds = filteredObjects.map(ass => ass.code);
                setSpecialtyFolder(prepareAssessmentList(assessmentIds));
            }
        }
    }, [assessmentsActive, assessmentsCfg, assessmentList, patientType, favAssessments]);

    const getAssessment = (type) => {
        switch (patientType) {
            case PATIENT_CONTEXT_TYPE.ED:
            case PATIENT_CONTEXT_TYPE.SDEC:
            case PATIENT_CONTEXT_TYPE.UTC:
                let assessmentFind = assessmentsCfg?.ED?.[type]?.find(ass => ass?.service?.wardsId?.[0] === patient?.wardId);
                if (!assessmentFind) {
                    assessmentFind = assessmentsCfg?.ED?.[type]?.find(ass => ass?.id === 'default');
                }                
                return prepareAssessmentList(_.uniq(assessmentFind?.assessmentList));
            case PATIENT_CONTEXT_TYPE.EDAU:
            case PATIENT_CONTEXT_TYPE.INPATIENT: {
                const flat = _.flatMap(assessmentsCfg?.INPATIENT?.[type], ass => ass?.assessmentList);
                return prepareAssessmentList(_.uniq(flat));
            }
            default:
                return [];
        }
    };

    const prepareAssessmentList = (listOfIds) => {
        const assessments = [];
        if (!_.isEmpty(listOfIds)) {
            _.forEach(listOfIds, id => {
                const findAss = _.find(assessmentsActive, {code: id});
                if (findAss) assessments.push(findAss);
            });
        }
        return assessments;
    };


    return (
        <div>
            {!isPatientED &&
                <AssessmentFolder disableSave={disableSave} assessments={specialtyFolder} folderType="Specialty"/>
            }
            <AssessmentFolder disableSave={disableSave} assessments={mandatoryFolder} folderType="Mandatory"/>

            <AssessmentFolder disableSave={disableSave} assessments={suggestedFolder} folderType="Suggested"/>

            <AssessmentFolder disableSave={disableSave} assessments={favouritesFolder} folderType="Favourites"/>

            <div className={classes.assessments}>
                <span className={classes.title}>
                    {t('Assessments')}
                </span>

                <div className={classes.counter}>
                    {assessmentsActive.length || 0}
                </div>
            </div>

            <div className={classes.list}>
                {assessmentsActive.map(ass => (
                    <AssessmentButton disableSave={disableSave} assessment={ass} key={ass.code}/>
                ))}
            </div>
        </div>
    );
};

export default AssessmentsFolders;